import { Nav, Profile } from "../index";
import { View } from "react-native";
import React from "react";

const TopSection = ({
  // onOpenMessagesModal,
  onOpenSidebar,
  // onOpenProfilePage,
}: {
  // onOpenMessagesModal: () => void;
  onOpenSidebar: () => void;
  // onOpenProfilePage: () => void;
}) => {
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <Profile />

      <Nav
        // onOpenMessagesModal={onOpenMessagesModal}
        onOpenSidebar={onOpenSidebar}
      />
    </View>
  );
};
export default TopSection;
